/**
 * Core theme script.
 *
 * @package Bamboo Theme
 */

// Main setup.
function bambooThemeDocumentReady() {

	// If the current page is a portfolio item set the portfolio menu item to active.
	if (jQuery('body').hasClass('single-portfolio')) {

		var portfolioLink = document.querySelectorAll('nav.desktop-only a[href*="our-portfolio"]');
		jQuery(portfolioLink).parent().addClass('current-menu-item');
		portfolioLink = document.querySelectorAll('nav.phone-and-tablet-only a[href*="our-portfolio"]');
		jQuery(portfolioLink).parent().addClass('current-menu-item');

	}

	// If the current page is an insights (blog) post sent the Insights item to active.
	if (jQuery('body').hasClass('single-post') || jQuery('body').hasClass('archive') || jQuery('body').hasClass('category')) {
		var insightsLink = document.querySelectorAll('nav.desktop-only a[href*="insights"]');
		jQuery(insightsLink).parent().addClass('current-menu-item');
		insightsLink = document.querySelectorAll('nav.phone-and-tablet-only a[href*="insights"]');
		jQuery(insightsLink).parent().addClass('current-menu-item');
	}


	// Initialise desktop menu hover element.
	//
	// The .menu-hover element is the small black pip that follows the
	// cursor across the nav and rests under the current page's menu item.
	//
	// On pages that AREN'T in the top nav (e.g. /product-builders/, which
	// isn't a top-level menu item) WordPress doesn't add .current-menu-item
	// to anything. The previous implementation handled that by forcing
	// .current-menu-item onto the first <li> just so the pip had somewhere
	// to rest — which had the side-effect of making "Home" look active on
	// every off-menu page (the SCSS rule for .current-menu-item a paints
	// the link black-on-white). Now we let the pip stay collapsed in that
	// case instead of fabricating an active state.
	jQuery('nav.desktop-only ul').append('<div class="menu-hover"></div>');
	var menu = jQuery('nav.desktop-only ul');
	var desktopMenuHover = menu.children('.menu-hover');

	var $currentLi = jQuery('nav.desktop-only ul li.current-menu-item').first();
	desktopMenuHover.css('transition', 'initial');
	if ($currentLi.length) {
		desktopMenuHover.css('left', $currentLi.position().left + ($currentLi.width() / 2));
	}
	desktopMenuHover.css('width', 0);

	jQuery('nav.desktop-only li').on('mouseenter', function () {
		bambooThemeMoveDesktopHover(this);
	});

	jQuery('nav.desktop-only ul').on('mouseleave', function () {
		var $rest = jQuery('nav.desktop-only ul li.current-menu-item').first();
		desktopMenuHover.css('transition', '0.75s cubic-bezier(0.10, 0.50, 0.10, 1)');
		if ($rest.length) {
			// Snap the 50px pip back under the active menu item.
			desktopMenuHover.css('left', $rest.position().left + ($rest.width() / 2) - 25);
			desktopMenuHover.css('width', 50);
		} else {
			// No active item (current page isn't in the nav) — collapse
			// the pip rather than fall back to faking an active state.
			desktopMenuHover.css('width', 0);
		}
	});

	// Initialise mobile menu hover element.
	jQuery('nav.phone-and-tablet-only ul').append('<div class="menu-hover"></div>');
	var menu = jQuery('nav.phone-and-tablet-only ul');
	var mobileMenuHover = menu.children('.menu-hover');
	var li = jQuery('nav.phone-and-tablet-only ul li').first();
	var a = li.children('a');
	mobileMenuHover.css('transition', 'initial');
	mobileMenuHover.css('left', a.position().left);
	mobileMenuHover.css('top', li.position().top+12);
	mobileMenuHover.css('width', a.width()+28);

	jQuery('nav.phone-and-tablet-only li').on('mouseenter', function () {
		bambooThemeMoveMobileHover(this);
	});

	jQuery('nav.phone-and-tablet-only ul').on('mouseleave', function () {
		mobileMenuHover.removeClass('visible');
	});

	// Initialise the news filter dropdown.
	const url = new URL(location.href);
	const filter = url.searchParams.get("filter");
	if (filter) {
		jQuery('#news-filter').val(filter);
	}

	jQuery('#news-filter').on('change', function () {
		document.location.href = '?filter=' + jQuery(this).val();
	});

	// Show mobile menu on button click.
	jQuery('.menu-button').on('click', function () {
		jQuery('nav.phone-and-tablet-only').addClass('visible');
	});

	// Hide mobile menu on button click.
	jQuery('.close-menu-button').on('click', function () {
		jQuery('nav.phone-and-tablet-only').removeClass('visible');
	});

	//Wrap iframe's to enable styling.
	jQuery( 'main iframe' ).wrap( '<div class="iframe-container"></div>' );

	// Enable click through on post blocks.
	jQuery('.wp-block-post').on('click', function(){
		var link = jQuery(this).find('a').attr('href');
		document.location.href = link;
	});

	// Enable click through on menu items.
	jQuery('nav li.menu-item').on('click', function(){
		var link = jQuery(this).find('a').attr('href');
		document.location.href = link;
	});

	// Enable click through on .click-through blocks.
	jQuery('.click-through').on('click', function(){
		var link = jQuery(this).find('a').attr('href');
		document.location.href = link;
	});

	// Header scroll behaviour + parallax effects.
	//
	// The header is now position: fixed (see bamboo-theme.scss) and
	// auto-hides on scroll-down, re-appears on scroll-up:
	//
	//   .scrolled  — set whenever scrollY > 0. CSS uses this to fade in
	//                the glassy backdrop. At y=0 the header sits clean
	//                against the page background.
	//   .is-hidden — set when actively scrolling DOWN past HIDE_THRESHOLD.
	//                Removed the moment the user scrolls UP by more than
	//                SCROLL_DELTA pixels. The mobile menu drawer being
	//                open also forces .is-hidden off — we don't want the
	//                bar fighting with the drawer's close button.
	//
	// Everything runs inside one rAF-throttled handler so we don't trigger
	// layout thrashing on every scroll event.
	//
	// The previous implementation overwrote `lastScrollY` outside the rAF
	// before the rAF body could read it, which made direction tracking
	// impossible — that's fixed here by reading the current scroll position
	// inside the rAF and only updating `lastScrollY` after the comparison.
	var SHOW_AT_TOP    = 4;   // px — within this many pixels of the top, never hide
	var HIDE_THRESHOLD = 80;  // px — must be scrolled at least this far before auto-hide engages
	var SCROLL_DELTA   = 6;   // px — minimum scroll movement to count as a direction
	var ticking        = false;
	var lastScrollY    = window.pageYOffset || document.documentElement.scrollTop;
	function bambooThemeOnScroll() {
		if ( ! ticking ) {
			window.requestAnimationFrame( function () {
				var currentY  = window.pageYOffset || document.documentElement.scrollTop;
				var $header   = jQuery( 'header' );
				var menuOpen  = jQuery( 'nav.phone-and-tablet-only' ).hasClass( 'visible' );

				// .scrolled: anywhere except the very top.
				if ( currentY > SHOW_AT_TOP ) {
					$header.addClass( 'scrolled' );
				} else {
					$header.removeClass( 'scrolled' );
				}

				// .is-hidden: only when scrolling down past the threshold,
				// and never while the mobile drawer is open.
				if ( menuOpen || currentY < HIDE_THRESHOLD ) {
					$header.removeClass( 'is-hidden' );
				} else {
					var delta = currentY - lastScrollY;
					if ( delta > SCROLL_DELTA ) {
						$header.addClass( 'is-hidden' );
					} else if ( delta < -SCROLL_DELTA ) {
						$header.removeClass( 'is-hidden' );
					}
				}

				// bambooThemeApplyParallax( currentY );

				lastScrollY = currentY;
				ticking     = false;
			} );
			ticking = true;
		}
	}
	jQuery(window).on('scroll', bambooThemeOnScroll);

	// Make sure the bar comes back the moment the mobile drawer closes,
	// even if the user hasn't scrolled.
	jQuery( '.close-menu-button' ).on( 'click', function () {
		jQuery( 'header' ).removeClass( 'is-hidden' );
	} );

	// Initialise Expand on Click elements.
	var expandOnClickElements = document.querySelectorAll('.expand-on-click');
	expandOnClickElements.forEach(element => {

		var text = element.innerHTML;
		element.setAttribute('data-text', text);

		var truncatedText = text.split(' ').slice(0,25).join(' ');
		truncatedText += '<span class="ellipsis">...</span><span class="hint">Click to read more</span>';
		element.setAttribute('data-truncated-text', truncatedText);

		element.innerHTML = truncatedText;

		element.addEventListener('click', () => {
			element.classList.toggle('expanded');
			if(element.classList.contains('expanded')) {
				element.innerHTML = element.getAttribute('data-text');
			} else {
				element.innerHTML = element.getAttribute('data-truncated-text');
			}
		});

	});

	// Initialise parallax effect on images. (Scroll handler is bound above,
	// inside the rAF-throttled bambooThemeOnScroll wrapper.)

	// bambooThemeApplyParallax(window.pageYOffset || document.documentElement.scrollTop);

	// Set the header's initial state correctly. If the page is loaded mid-
	// scroll (browser back, refresh after scrolling, hash link) the user
	// would otherwise see the logo flash for a moment until the first
	// scroll event fired — calling the handler once here covers that.
	bambooThemeOnScroll();

	// Initialise ken-burns effect on cover images.
	jQuery('.ken-burns').each(function () {
		var image = jQuery(this).find('img');
		if (image.length > 0) {
			image.addClass('ken-burns');
			image.css('transition', 'transform 15s ease-in-out');
			image.css('transform', 'scale(1.2)');
		}
	});

}
jQuery( document ).ready( bambooThemeDocumentReady );


// Apply parallax effect to images. Receives the current scroll position so the
// caller (the rAF-throttled scroll handler) can avoid extra layout reads.
function bambooThemeApplyParallax(scrollTop) {

	if (typeof scrollTop !== 'number') {
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	}
	var windowHeight = window.innerHeight;
	var scrollBottom = scrollTop + windowHeight;

	function applyToSelector(selector, factor, scaleFactor) {
		jQuery(selector).each(function () {
			var $el = jQuery(this);
			var rect = this.getBoundingClientRect();
			// rect.top/.bottom are relative to the viewport; cheaper than .offset().
			if (rect.bottom < 0 || rect.top > windowHeight) {
				return; // Off-screen — skip.
			}
			var offsetTop = rect.top + scrollTop;
			var yPos = (scrollTop - offsetTop) * factor;
			$el.find('img').css('transform', 'translateY(' + yPos + 'px) scale(' + scaleFactor + ')');
		});
	}

	applyToSelector('.wp-block-cover:not(.ken-burns):not(.no-parallax)', 0.2, 1.2);
	applyToSelector('.portfolio-item', 0.1, 1.5);
	applyToSelector('.wp-block-latest-posts__featured-image', 0.1, 1.5);
	applyToSelector('.wp-block-media-text__media', 0.05, 1.3);
}


// Show dropdown menu.
function bambooThemeShowMenu() {

	var li = jQuery(this);
	var menu = li.children().last();
	var menuHeight = 0;
	menu.children().each(function () {
		menuHeight += jQuery(this).outerHeight();
	});
	li.addClass('active');
	menu.css('height', menuHeight).addClass('visible');
	menu.addClass('active');

}


// Hide dropdown menu.
function bambooThemeHideMenu() {

	var li = jQuery(this);
	var menu = li.children().last();
	li.removeClass('active');
	li.find('.sub-menu').removeClass('active');
	menu.css('height', 0).removeClass('visible');

}


// Toggle mobile sub-menu sub-menu.
function bambooThemeToggleSubMenu() {

	var button = jQuery(this);

	button.toggleClass('active');
	var subMenu = button.parent().children().last();

	if (button.hasClass('active')) {

		var subMenuHeight = 0;
		subMenu.children().each(function () {
			subMenuHeight += jQuery(this).outerHeight();
		});
		subMenu.css('height', subMenuHeight);
		subMenu.addClass('visible');

	} else {

		subMenu.css('height', 0);
		subMenu.removeClass('visible');

	}

	return false;

}

// Move the desktop hover element.
function bambooThemeMoveDesktopHover(target) {

	var li = jQuery(target);
	var menu = li.parent();
	var hover = menu.children('.menu-hover');
	hover.css('transition', '0.5s cubic-bezier(0.10, 0.50, 0.10, 1');
	hover.css('left', li.position().left);
	hover.css('width', li.width());

}

// Move the mobile hover element.
function bambooThemeMoveMobileHover(target) {

	var li = jQuery(target);
	var a = li.children('a');
	var menu = li.parent();
	var hover = menu.children('.menu-hover');

	if(!hover.hasClass('visible')) {
		hover.css('transition', 'initial');
		hover.css('left', a.position().left);
		hover.css('top', li.position().top+12);
		hover.css('width', a.width()+28);
		hover.css('transition', '0.5s cubic-bezier(0.10, 0.50, 0.10, 1');
		hover.addClass('visible');
	} else {
		hover.css('left', a.position().left);
		hover.css('top', li.position().top+12);
		hover.css('width', a.width()+28);
	}

}

// Toggle search popup.
function bambooThemeToggleSearch() {

	jQuery('.search-popup').toggleClass('visible');
	if(jQuery('.search-popup').hasClass('visible')) {
		jQuery('.searchform #s').focus();
	}

}

